<template>
    <div :class="['partner-tile', {'partner-tile--hidden-logo': isLogoHidden}]">
        <partner-logo v-if="isLogo"
            id="partner-tile-logo"
            class="partner-tile__logo"
            :show-placeholder="true"
            :url="item.partnerLogo"
        />

        <div v-else
            id="partner-tile-currency-symbol"
            class="currency-symbol"
        >
            <span>{{ item.partnerLogo }}</span>
        </div>

        <div :class="['partner-tile__details', {'partner-tile__details--small' : isSmall}]">
            <span id="partner-tile-name">{{ item.name }}</span>

            <div id="partner-tile-shortname"
                class="partner-tile__shortname"
            >
                {{ item.shortName }}
            </div>
        </div>
    </div>
</template>

<script>
// Components
import partnerLogo from '@webapp/components/partner-logo/partner-logo.vue';

export default {
    name: 'partner-logo-tile',
    components: {
        partnerLogo,
    },
    props: {
        item: {
            type: Object,
            default: () => ({}),
        },
        isSmall: {
            type: Boolean,
            default: false,
        },
        isLogoHidden: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        isLogo() {
            return this.item.partnerLogo ? this.item.partnerLogo.match(/.(jpeg|png|gif|webp)/g) : true;
        },
    },
};
</script>

<style lang="scss" scoped>
.partner-tile {
    display: flex;
    align-items: center;

    &--hidden-logo {
        .partner-tile {
            &__logo {
                @include max-width(xs) {
                    display: none;
                }

                @include max-width(sm) {
                    width: 3.5rem;
                    height: 3.5rem;
                }
            }

            &__details {
                font-size: 2.6rem;
                @include max-width(xs) {
                    padding-left: 0;
                }
                @include max-width(sm) {
                    padding-left: 1rem;
                    font-size: 2rem;
                }
                @include min-width(xl) {
                    font-size: 3rem;
                    line-height: 4rem;
                }
            }

            &__shortname {
                @include max-width(sm) {
                    line-height: 1;
                }
            }
        }
    }

    &__logo {
        width: 5rem;
        height: 5rem;
        align-self: auto;
        position: relative;

        @include max-width(sm) {
            width: 4.5rem;
            height: 4.5rem;
        }
    }

    &__details {
        position: relative;
        box-sizing: border-box;
        padding-left: 1rem;
        font-size: 3.6rem;
        line-height: 4rem;
        font-weight: 600;
        text-align: left;
        max-width: 17rem;
        color: $cyprus-color;

        @include max-width(sm) {
            font-size: 2.6rem;
            line-height: 3rem;
            max-width: 12rem;
        }

        span {
            display: block;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 1.5rem;
            line-height: 2rem;

            @include max-width(sm) {
                font-size: 1rem;
            }
        }

        &--small {
            font-size: 2.6rem;
            line-height: 3rem;

            @include min-width(xl) {
                font-size: 3rem;
                line-height: 4rem;
            }
        }
    }
}

.currency-symbol {
    box-sizing: border-box;
    width: 5.5rem;
    height: 5.5rem;
    border: 0.3rem solid $orange-peel-color;
    color: $orange-peel-color;
    background: $white-color;
    border-radius: 100%;
    font-size: 3rem;
    font-weight: 700;
    line-height: 5.5rem;
    text-align: center;

    @include max-width(sm) {
        width: 4.5rem;
        height: 4.5rem;
        line-height: 4.5rem;
        font-size: 2.5rem;
    }

    span {
        position: relative;
        top: -0.2rem;
    }
}
</style>